import { ROUTES } from "@/constants/routes";
import { useAppNavigate } from "@/hooks/pane-routing";
import { route } from "@/utils/route";
import { useCallback } from "react";

/** Opens `SkillTemplatePane` for a template id in the right pane. */
export function useOpenSkillTemplate() {
  const appNavigate = useAppNavigate();

  return useCallback(
    (templateId: string) => {
      if (!templateId) return;
      appNavigate({
        pane: "rightPane",
        to: route(ROUTES.SKILL_TEMPLATES.SHOW, { id: templateId }),
      });
    },
    [appNavigate],
  );
}
